import { DEFAULT_ENDPOINT } from "constants/variables";
import {
    requestPage,
    receivePage,
    requestPagedPages,
    receivePagedPages
} from "./page.creators";

const ENDPOINT = `${DEFAULT_ENDPOINT}/pages`;

const getPage = slug => {
    return dispatch => {
        dispatch(requestPage());
        fetch(`${ENDPOINT}/?slug=${slug}`)
            .then(res => res.json())
            .then(json => dispatch(receivePage(json[0])));
    };
};

const getPagedPages = (pagesPerPage, currentPage) => {
    return dispatch => {
        dispatch(requestPagedPages());
        fetch(`${ENDPOINT}/?per_page=${pagesPerPage}&page=${currentPage}`)
            .then(res => res.json())
            .then(json => dispatch(receivePagedPages(json)));
    };
};

export { getPage, getPagedPages };



// WEBPACK FOOTER //
// ./src/actions/page/page.functions.js